import apiClient from './apiClient';

export const contactApi = {
	// Send contact form email
	sendContactEmail: async (formData) => {
		try {
			const response = await apiClient.post(`/api/contact`, formData);
			return response.data;
		} catch (error) {
			console.error('Contact API error details:', {
				status: error.response?.status,
				data: error.response?.data,
				message: error.message,
			});
			throw error.response?.data || error;
		}
	},

	// Send password reset email
	sendPasswordResetEmail: async (email) => {
		try {
			const response = await apiClient.post(
				`/api/users/forgot-password`,
				{ email }
			);
			return response.data;
		} catch (error) {
			throw error.response?.data || error;
		}
	},

	// Reset password with code
	resetPassword: async (email, code, newPassword) => {
		try {
			const response = await apiClient.post(`/api/users/reset-password`, {
				email,
				code,
				newPassword,
			});
			return response.data;
		} catch (error) {
			throw error.response?.data || error;
		}
	},

	// Send push notification
	sendPushNotification: async (notificationData) => {
		try {
			const response = await apiClient.post(
				`/api/notifications`,
				notificationData
			);
			return response.data;
		} catch (error) {
			throw error.response?.data || error;
		}
	},
};
